import { currency } from '~/lib/format';
import { DealSkuCardType } from '~/components/sku';
import { useMemo } from 'react';

/**
 * Render the price and original price of a deal.
 */
export const DealPrice = ({ deal }: { deal: DealSkuCardType }) => {
  const priceSuffix = useMemo(() => {
    if (['annual', 'lifetime'].includes(deal.default_plan?.plan_type)) {
      return deal.default_plan?.plan_type;
    }

    return null;
  }, [deal.default_plan]);

  return (
    <div>
      <span>
        {deal.price === 0 && 'FREE'}
        {deal.price > 0 && (
          <>
            {currency(deal.price)}
            {priceSuffix && (
              <span className="text-sm font-normal">/{priceSuffix}</span>
            )}
          </>
        )}
      </span>
      {deal.original_price > 0 && (
        <span className="ml-2 text-sm font-normal text-grace line-through">
          {currency(deal.original_price)}
        </span>
      )}
    </div>
  );
};
